
export default class Map {

    constructor(el) {
        this.isActive = false
        this.container = el;

        this.mapEl = el.querySelector('.map__gmap');
        this.key = this.container.dataset.key;
        this.lng = parseFloat(this.container.dataset.lon);
        this.lat = parseFloat(this.container.dataset.lat);

        this.loadMap();

        if(window.mapsLoaded){
            this.initMap();
        }
        else{
            this.setEvents();
        }
    }

    static get selector() {
        return '.map';
    }

    initMap() { 

        this.map = new google.maps.Map(this.mapEl, {
            center: {
                lat: this.lat,
                lng: this.lng
            },
            zoom: 16,
            disableDefaultUI: true

        });
        this.createMarker();
        this.map.addListener('tilesloaded', () => {
            if(!this.isActive){
                this.active();
            }
        });
    }


    createMarker() {
        new google.maps.Marker({
            position: new google.maps.LatLng(this.lat, this.lng),
            map: this.map
        });
    }

    loadMap() {
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key + '&callback=initMap';
        script.async = true;
        // Append the 'script' element to 'head'
        document.head.appendChild(script);
    }

    active() {
        this.container.classList.add('map--active');
        this.isActive = true;
    }

    setEvents() {
        window.addEventListener('mapsloaded',(e) => {this.e_mapsLoaded(e)}, false);
    }
    
    /**
     * Events
     */

    e_mapsLoaded(e) {
        this.initMap();
    }
}